export default __webpack_public_path__ + "static/media/Sustainable fashion chain.be32969c.svg";